import { Command } from 'commands/Commands';

export class ChangeArticleDate extends Command {
  type: string = 'BlogArticle.ChangeDate';
  constructor(public id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
